import {
	Button,
	Divider,
	Flex,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalOverlay,
	Text
} from '@chakra-ui/react';
import { formatPrice } from '../../../utils/format';

// Compra é irreversível (debita crédito), então o total e o saldo restante
// aparecem antes de confirmar — nunca direto no clique da tabela.
export default function ConfirmPurchaseModal({
	isOpen,
	onClose,
	count,
	total,
	balance,
	loading,
	onConfirm
}: {
	isOpen: boolean;
	onClose: () => void;
	count: number;
	total: number;
	balance: number;
	loading: boolean;
	onConfirm: () => void;
}) {
	const remaining = balance - total;

	return (
		<Modal isOpen={isOpen} onClose={onClose} isCentered>
			<ModalOverlay />
			<ModalContent borderRadius='20px'>
				<ModalHeader>Confirmar compra</ModalHeader>
				<ModalCloseButton />
				<ModalBody>
					<Text fontSize='sm' mb='16px'>
						Você vai liberar os dados completos de <b>{count}</b> lead(s). Leads que ainda estão no seu histórico
						não são cobrados de novo.
					</Text>
					<Flex justify='space-between' mb='6px'>
						<Text fontSize='sm'>Total</Text>
						<Text fontSize='sm' fontWeight='700'>
							{formatPrice(total)}
						</Text>
					</Flex>
					<Flex justify='space-between' mb='6px'>
						<Text fontSize='sm'>Saldo atual</Text>
						<Text fontSize='sm'>{formatPrice(balance)}</Text>
					</Flex>
					<Divider my='8px' />
					<Flex justify='space-between'>
						<Text fontSize='sm'>Saldo após a compra</Text>
						<Text fontSize='sm' fontWeight='700' color={remaining < 0 ? 'red.500' : undefined}>
							{formatPrice(remaining)}
						</Text>
					</Flex>
				</ModalBody>
				<ModalFooter>
					<Button variant='ghost' mr='8px' onClick={onClose}>
						Cancelar
					</Button>
					<Button variant='brand' isLoading={loading} isDisabled={remaining < 0} onClick={onConfirm}>
						Comprar
					</Button>
				</ModalFooter>
			</ModalContent>
		</Modal>
	);
}
